const formatDate = (date: any, oldformat = "") => {
  if (
    date == "" ||
    date == null ||
    date == undefined ||
    date == "0000-00-00 00:00:00"
  )
    return "";
  if (oldformat == "mm-dd-yyyy") {
    return date
      ? date.substring(6, 10) +
          "-" +
          date.substring(0, 2) +
          "-" +
          date.substring(3, 5)
      : null;
  }
  //if date is today, will show today date
  if (date === "today" || date === "Today") {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const formatter = new Intl.DateTimeFormat("zh-Hans-CN", options);
    return formatter.format(new Date()).replace(/\//g, "-");
  }
  if (date === "yesterday" || date === "yesterday") {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const formatter = new Intl.DateTimeFormat("zh-Hans-CN", options);
    return formatter
      .format(new Date(Date.now() - 86400000))
      .replace(/\//g, "-");
  }
  //get 10 digits date
  if (date === null || date === undefined) return "";
  if (date.toString().length > 10) {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const formatter = new Intl.DateTimeFormat("zh-Hans-CN", options);
    return formatter.format(new Date(date)).replace(/\//g, "-");
  } else {
    date = date.toString().slice(0, 10);
    return date;
  }
};

export default formatDate;
